import { render, staticRenderFns } from "./InvoicingRules.vue?vue&type=template&id=a6f39f72&"
import script from "./InvoicingRules.vue?vue&type=script&lang=js&"
export * from "./InvoicingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports